/* Auto Generated */

export enum LocalTrainingType {
	openRoster = 229380005,
	companyTrainingLocal = 229380017,
	companyTrainingRemote = 229380018,
	eLearning = 229380019,
	modular = 229380020,
}
